import React, { FC } from "react";
import { Modal, useNotifications } from "sprint-common-web";

import { useFileRecordApi } from "../../../../../../../common/api/master-api/file-records/useFileRecordApi";
import { CourseOfActionReference } from "../../../../../../../common/types/CourseOfActionReference";
import { FixedBillingReference } from "../../../../../../../common/types/FixedBillingReferfence";
import { FileRecordStatusDetails } from "../../../../../common/types/FileRecordStatusDetails";
import { FileRecordStatusDetailsForm } from "../../../../../forms/status/status-details/FileRecordStatusDetailsForm";

type WaitingForClientResponseStatusDialogProps = {
    fileRecordId: string;
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (statusDetails?: FileRecordStatusDetails) => void;
};

export const WaitingForClientResponseStatusDialog: FC<WaitingForClientResponseStatusDialogProps> = ({
    isOpen,
    onClose,
    onConfirm,
    fileRecordId
}) => {
    const { success, error } = useNotifications();
    const { changeFileRecordToWaitingForClientResponse } = useFileRecordApi();

    const handleStatusDetailsChange = async ({
        courseOfAction,
        details,
        fixedBilling
    }: {
        details: string;
        courseOfAction: CourseOfActionReference;
        fixedBilling?: FixedBillingReference;
    }) => {
        try {
            await changeFileRecordToWaitingForClientResponse({
                fileRecordId,
                details,
                courseOfActionId: courseOfAction.id,
                fixedBillingId: fixedBilling?.id
            });

            onConfirm({
                courseOfAction: courseOfAction.name,
                fixedBilling: fixedBilling?.name,
                details
            });
            success("File record successfully changed to Waiting for client response");
        } catch (e) {
            console.log(e);

            error("File record status change to Waiting for client response failed");
        }

        onClose();
    };

    return (
        <Modal
            headerText="Change file record status to Waiting for client response"
            isBlocking={true}
            isOpen={isOpen}
            onDismiss={onClose}
        >
            <FileRecordStatusDetailsForm onConfirm={handleStatusDetailsChange} onCancel={onClose} />
        </Modal>
    );
};
